import { Flex } from '@betterment/style-closet-react';

import ContentCard from '../../Shared/components/ContentCard';
import { DynamicShimmerLoader } from '../../Shared/components/ShimmerLoaders';

export function MessageCardLoader() {
  return (
    <ContentCard p="8" mb={[3, 3, 8, 8]} data-testid="messageCardLoader">
      <Flex mb="6">
        <Flex display="block" flexBasis="26rem">
          <DynamicShimmerLoader height="2rem" width="26rem" />
        </Flex>
      </Flex>
      <Flex>
        <Flex display="block" flexBasis="20rem">
          <DynamicShimmerLoader height="2rem" width="20rem" />
        </Flex>
      </Flex>
    </ContentCard>
  );
}
